import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import { useBoolean } from '@/src/hooks/use-boolean';
import { AddNoteIcon } from '../ui/AddNoteIcon';
import { AddImageIconSm } from '../ui/AddImageIcon';
import { AddVideoIconSm } from '../ui/AddVideoIcon';
import { AddTitleIcon } from '../ui/AddTitleIcon';
import { useCreateTileRequest } from '@/src/hooks/use-create-tile-request';
import { Button } from '@workspace/ui/components/button';
import { Icon } from '../ui';
import { cn } from '@workspace/ui/lib/utils';

export const AddTilesToolbar = () => {
  const isOpenLink = useBoolean(false);
  const requestTileAddition = useCreateTileRequest(
    (s) => s.requestTileAddition
  );

  return (
    <div className="flex items-center md:gap-2 gap-5 justify-end">
      <AddImageIconSm onClick={requestTileAddition} />
      <AddVideoIconSm onClick={requestTileAddition} />
      <AddNoteIcon onClick={requestTileAddition} />
      <DropdownMenu
        modal={false}
        onOpenChange={(open) => isOpenLink.setValue(open)}
      >
        <DropdownMenuTrigger asChild>
          <Button
            className={cn(
              'border-1 border-black/5 bg-white rounded-[8px] overflow-hidden size-8 custom-shadow hover:bg-bg-gray transition-all ease-in-out duration-300 flex items-center justify-center',
              {
                'bg-bg-gray': isOpenLink.value,
              }
            )}
          >
            <Icon
              name="link-2"
              className="bg-transparent size-4 text-[#1185FE]"
            />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="text-black/80 text-xs font-medium" align="center" side="top">
          <DropdownMenuItem
            className="flex text-xs items-center gap-2 py-1 px-2 group-hover:text-black cursor-pointer"
            onClick={() => requestTileAddition('add-social')}
          >
            <Icon name="people" className="size-3.5 group-hover:text-black" />
            Social Link
          </DropdownMenuItem>
          <DropdownMenuItem
            className="flex text-xs items-center gap-2 py-1 px-2 cursor-pointer"
            onClick={() => requestTileAddition('add-custom')}
          >
            <Icon name="built-bit" className="size-3.5" />
            Custom Block
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AddTitleIcon onClick={requestTileAddition} />
    </div>
  );
};
